import React, {useEffect, useState} from 'react';
import { withTranslation } from 'react-i18next';
import {useHistory, useParams} from 'react-router-dom';
import {useStore} from "store/context";
import { isMobile } from 'helpers/Mobile';

import { FidelizacionService } from 'services/FidelizacionService';
import { UnidadService } from 'services/UnidadService';
import useRequest from 'hooks/useRequest';

import GradientButton from '../../../components/atoms/GradientButton';
import MainLayout from '../../../components/Layouts/MainLayout';
import InputText from '../../../components/atoms/InputText';

import arrowright from 'assets/images/arrow-right.png';

import './styles.scss';
import Form from "react-bootstrap/Form";

const FidelizarView = (props) => {
    const history = useHistory();

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, 
        dealWithError
    } = useRequest();

    const { id } = useParams();


    const [{}, dispatch] = useStore();
    const [uf, setUf] = useState([]);

    const [codigosPostales, setCodigosPostales] = useState([]);
    const [codigosAreas, setCodigosAreas] = useState([]);
    const [caracteristicas, setCaracteristicas] = useState([]);
    const [tipoDocumento, settipoDocumento] = useState("");
    const [numDocumento, setnumDocumento] = useState("");
    const [entre, setentre] = useState("");
    const [codPostal, setcodPostal] = useState("");
    const [mail, setmail] = useState("");
    const [codigoArea, setcodigoArea] = useState(false);
    const [caracteristica, setcaracteristica] = useState(false);
    const [numero, setnumero] = useState(false);

    useEffect(() => {
        console.log(id);
        UnidadService.unidad(id)
            .then(data => {
                setUf(data);
            }).catch((error) => {
                dealWithError(error, 'Error al obtener la unidad funcional');
            });

        FidelizacionService.obtenerCodigosPostales()
            .then(data => {
                setCodigosPostales(data);
            }).catch((error) => {
            dealWithError(error, 'Error al obtener los códigos postales');
        });

        FidelizacionService.obtenerCodigosAreas()
            .then(data => {
                setCodigosAreas(data);
            }).catch((error) => {
                dealWithError(error, 'Error al obtener los códigos areas');
            });

        FidelizacionService.obtenerFidelizacion(id)
            .then(data => {
                setnumDocumento(data.numero_documento);
                setentre(data.direccion);
                setcodPostal(data.codigo_postal);
                setmail(data.mail_alternativo);
                settipoDocumento(data.tipo_documento);
                setcodigoArea(data.codigo_area);
                setcaracteristica(data.caracteristica);
                setnumero(data.numero);
            }).catch((error) => {
            dealWithError(error, 'Error al obtener la fidelización');
        });

    }, []);

    useEffect(() => {
        if (codigoArea === false || codigoArea === null || codigoArea === undefined) {
            setCaracteristicas([]);
            return;
        }
        const areaId = String(codigoArea).trim();
        if (!areaId) {
            setCaracteristicas([]);
            return;
        }
        FidelizacionService.obtenerCaracteristicas(areaId)
            .then(data => {
                setCaracteristicas(data);
            }).catch((error) => {
                dealWithError(error, 'Error al obtener los caracteristicas');
            });
    }, [codigoArea]);


    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            tipo_documento: tipoDocumento === 'NI' ? 'DNI' : tipoDocumento,
            numero_documento: numDocumento,
            direccion: entre,
            codigo_postal: codPostal,
            email: mail,
            codigo_area: codigoArea,
            caracteristica: caracteristica,
            numero: numero
        }
        FidelizacionService.fidelizar(data, id)
            .then(data => {
                afterSubmit();
                dispatch({
                    type: 'resetUnidades',
                    payload: {},
                });
                history.push('/unidades_adheridas');
            }).catch((error) => {
                dealWithError(error, '');
            });
    }

    const unidadesAdheridas = (e) => {
        e.preventDefault();

        history.push('/unidades_adheridas');
    };

    return (
        <MainLayout>
            {!isMobile && <div className="fidelizar-datosuf">
                <p><img src={arrowright} alt="UF" title="UF" /> <strong>UF {uf.unidad}</strong> - {uf.alias} - <br></br>
                <span class="direccion">{uf.direccion}</span></p>
            </div>}
            <div className="fidelizar-volver">
                <GradientButton legend={'VOLVER'} handleClick={unidadesAdheridas} />
            </div>
            <div className="fidelizar-container">
                <div className="fidelizar-content">
                    <form className="fidelizar-form" onSubmit={handleSubmit}>
                        <h1 className="fidelizar-title">Editar Datos</h1>
                        {isMobile && <div className="fidelizar-datosuf">
                            <p><strong>UF {uf.unidad}</strong> - {uf.alias} - <br></br>
                                <span class="direccion">{uf.direccion}</span></p>
                        </div>}
                        <div className="fidelizar-input-group">
                            <div className="fidelizar-input-container">
                                {(tipoDocumento === "NI") && <>
                                    <div className="input-text-container">
                                        <Form.Group controlId="fidelizar-dropdown-select">
                                            <Form.Label>TIPO DOCUMENTO</Form.Label>
                                            <Form.Control
                                                custom
                                                as="select"
                                                size="lg"
                                                value={tipoDocumento}
                                                onChange={(event) => { settipoDocumento(event.target.value) }}
                                                disabled={(tipoDocumento === "DNI" ? 'disabled' : '')}>
                                                <option value="DNI">DNI</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                    <div className="input-error">
                                        {errors.tipo_documento}
                                    </div>
                                    </>
                                }
                                {(tipoDocumento !== "NI") && <InputText label="TIPO DOCUMENTO" disabled="disabled"
                                    handleChange={(event) => { setnumDocumento(event.target.value) }} error={errors.tipoDocumento} value={tipoDocumento} />
                                }
                            </div>
                        </div>
                        <div className="fidelizar-input-group">
                            <div className="fidelizar-input-container">
                                <InputText id="numDocumento" label="NÚMERO DE DOCUMENTO" disabled={(tipoDocumento !== "NI" && tipoDocumento !== "DNI")}
                                    handleChange={(event) => { setnumDocumento(event.target.value) }} error={errors.numero_documento} value={numDocumento} />
                            </div>
                        </div>
                        <div className="fidelizar-input-group">
                            <div className="fidelizar-input-container">
                                <InputText id="entre" label="ENTRE CALLES"
                                           handleChange={(event) => { setentre(event.target.value) }} error={errors.entre}  value={entre} />
                            </div>
                        </div>
                        <div className="fidelizar-input-group">
                            <div className="fidelizar-input-container">
                                <div className="input-text-container telefono">
                                    <Form.Group >
                                        <Form.Label>TELÉFONO</Form.Label>
                                    </Form.Group>
                                    <div className="fidelizar-inputs-telefono">
                                        <div className="input-text-container">
                                            <Form.Group controlId="fidelizar-dropdown-select">
                                                <Form.Control
                                                    custom
                                                    as="select"
                                                    size="lg"
                                                    value={codigoArea}
                                                    onChange={(event) => { setcodigoArea(event.target.value) }}>
                                                    {!codigoArea && <option value=""></option>}
                                                    {codigosAreas.map((codigo) => {
                                                        return <option value={codigo.codigo_area}>{codigo.codigo_area}</option>
                                                            ;
                                                    })}
                                                </Form.Control>
                                            </Form.Group>
                                        </div>
                                        <div className="input-text-container">
                                            <Form.Group controlId="fidelizar-dropdown-select">
                                                <Form.Control
                                                    custom
                                                    as="select"
                                                    size="lg"
                                                    value={caracteristica}
                                                    onChange={(event) => { setcaracteristica(event.target.value) }}>
                                                    {!caracteristica && <option value=""></option>}
                                                    {caracteristicas.map((codigo) => {
                                                        return <option value={codigo.caracteristica}>{codigo.caracteristica}</option>
                                                            ;
                                                    })}
                                                </Form.Control>
                                            </Form.Group>
                                        </div>
                                        <div className="input-text-container">
                                            <Form.Group controlId="fidelizar-numero">
                                                <Form.Control value={numero} type="text" onChange={(event) => { setnumero(event.target.value) }} />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="input-error">
                                    <p>{errors.telefono}</p>
                                    <p>{errors.codigo_area}</p>
                                    <p>{errors.caracteristica}</p>
                                    <p>{errors.numero}</p>
                                </div>
                            </div>
                        </div>
                        <div className="fidelizar-input-group">
                            <div className="fidelizar-input-container">
                                <InputText id="mail" label="E-MAIL ALTERNATIVO"
                                           handleChange={(event) => { setmail(event.target.value) }} error={errors.email}  value={mail} />
                            </div>
                        </div>

                        {(success === false && message) &&
                            <p className="error-messages">{message}</p>
                        }
                        <div className="fidelizar-button">
                            <GradientButton legend={'ACTUALIZAR'} disabled={submitted}
                                handleClick={handleSubmit} type={'submit'} />
                        </div>
                    </form>
                </div>
            </div>
        </MainLayout>
    );
}

export default withTranslation()(FidelizarView);